<template>
    <div>
        <!--<div class="optional-row mt10">-->
        <!--<div class="fr">-->
        <!--<button class="swb-btn swb-btn-mini mr10" @click="goBack">返回</button>-->
        <!--&lt;!&ndash;<button class="swb-btn swb-btn-mini mr10" @click="submitClick">提交</button>&ndash;&gt;-->
        <!--</div>-->
        <!--</div>-->

        <div class="content-caption dashed bg-white">
            <span>配货机构</span>
        </div>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small mr10" @click="showShopDlg()">选择机构</button>
            </div>
        </div>
        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th style="text-align: left; width: 300px;">机构名称</th>
                <th style="text-align: left">地址信息</th>
                <th style="text-align: left">详细地址</th>
                <th style="text-align: left; width: 120px;">联系人</th>
                <th style="text-align: left; width: 120px;">联系电话</th>
                <!--<th style="text-align: left; width: 150px;">邮箱</th>-->
                <th style="text-align: left; width: 150px;">要求到货日期</th>
                <th style="text-align: left; width: 200px;">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr v-if="comnAllocForm.allocForms.length > 0" v-for="allocForm in comnAllocForm.allocForms" class="row">
                <td style="text-align: left; width: 300px;">{{allocForm.buyerShopName}}</td>
                <td style="text-align: left">
                    <div class="inline-block mr10" style="width: 500px">{{allocForm.buyerRecvRegionName}}</div>
                </td>
                <td style="text-align: left">
                    <el-input class="inline-block" placeholder="详细地址" style="width: 98%" v-model="allocForm.buyerRecvStreet"></el-input>
                </td>
                <td style="text-align: left; width: 120px;">
                    <el-input class="inline-block" placeholder="联系人" style="width: 95%" v-model="allocForm.buyerRecvContractName"></el-input>
                </td>
                <td style="text-align: left; width: 120px;">
                    <el-input class="inline-block" placeholder="联系电话" style="width: 95%" v-model="allocForm.buyerRecvContactTel"></el-input>
                </td>
                <!--<td style="text-align: left; width: 150px;">{{allocForm.contactEmail}}</td>-->
                <td style="text-align: left; width: 150px;">
                    <el-date-picker class="inline-block" style="width: 95%" v-model="allocForm.desireArriveDate" type="date" placeholder="选择日期" :picker-options="pickerOptions0"></el-date-picker>
                </td>
                <td style="text-align: left; width: 160px;">
                    <span class="swb-btn-link" @click="showShopAddrDlg(allocForm)">选择地址</span>
                    <span class="swb-btn-link" @click="removeRetailerCom(allocForm.buyerShopId)">移除</span>
                </td>
            </tr>
            </tbody>
            <tfoot class="foot" v-if="comnAllocForm.allocForms.length <= 0">
            <tr>
                <td colspan="7" style="text-align: center; line-height: 40px;">
                    <span class="font-gray3">暂无数据</span>
                </td>
            </tr>
            </tfoot>
        </table>
        <div class="content-caption dashed bg-white">
            <span>商品信息</span>
        </div>
        <div class="form-single">
            <div class="title required" style="width: 80px;">供应商</div>
            <div class="content" style="padding-left: 95px;width: calc(100% - 95px - 20px);">
                <div class="pos-rel" style="width: 313px">
                    <el-input class="width-2x bottom-line" :disabled="true" v-model="comnAllocForm.sellerName"></el-input>
                    <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="sellerSelect"></i>
                </div>
            </div>
        </div>
        <div class="form-single">
            <div class="title required" style="width: 80px;">税率(%)</div>
            <div class="content" style="padding-left: 95px;width: calc(100% - 95px - 20px);">
                <div class="pos-rel" style="width: 313px">
                    <el-input v-model="comnAllocForm.taxRate" class="width-2x" @change="taxRateChange(comnAllocForm.taxRate)"></el-input>
                </div>
            </div>
        </div>
        <div>
            <button class="swb-btn swb-btn-small mb10" @click="showSkuDlg()">选择商品</button>
            <el-form :model="comnAllocForm">
                <el-table ref="multipleTable" :data="comnAllocForm.itemList" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column align="left" prop="title" label="名称"></el-table-column>
                    <el-table-column align="left" prop="catName" label="分类" width="120"></el-table-column>
                    <el-table-column align="left" prop="brandName" label="品牌" width="120"></el-table-column>
                    <el-table-column align="center" prop="asmblAccFlag" label="组装件" width="130">
                        <template slot-scope="scope">
                            <el-radio-group v-model="scope.row.asmblAccFlag">
                                <el-radio :label="true">是</el-radio>
                                <el-radio :label="false">否</el-radio>
                            </el-radio-group>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="price" label="含税价(元)" width="90">
                        <template slot-scope="scope">
                            <el-input type="text" v-model="scope.row.price" @change="changePrice(scope.row)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="taxRate" label="税率(%)" width="90"></el-table-column>
                    <el-table-column align="right" prop="ntxPrice" label="未税价(元)" width="90">
                        <template slot-scope="scope">
                            <span v-if="scope.row.ntxPrice != null">{{scope.row.ntxPrice}}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" label="下单数量" width="90">
                        <template slot-scope="scope">
                            <el-input type="text" v-model="scope.row.quantity"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="unit" label="单位" width="80"></el-table-column>
                    <el-table-column align="left" label="说明">
                        <template slot-scope="scope">
                            <el-input type="text" v-model="scope.row.desc"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" label="操作" width="100">
                        <template slot-scope="scope">
                            <a class="swb-btn-link" @click="removeGoods(allocFormItem.skuId)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
        </div>
    </div>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf';
    import goodsOrderApi from '../../api/goodsOrder'
    import userApi from '../../api/user'
    import retailerApi from '../../api/retailer'
    import { openRetailerComTreeMultiSelectDlg } from '../orgStruct/selectDlg'
    import { openVendorSelectComnDlg } from '../vendor/selectDlg'
    import{ openSkuListSelectDlg } from '../goods/selectDlg'
    //
    import SwbRetailerAddrSelect from '../retailer/RetailerAddrSelect'
    Vue.regist(SwbRetailerAddrSelect);
    import SwbOrderGoodsAllocFormList from '../order/OrderGoodsAllocFormList'
    Routes.add(SwbOrderGoodsAllocFormList);
    //
    export default {
        name: 'swb-order-goods-alloc-form-template',
        avlActions: '',
        avlScopes: 'retailer',
        desc: '配货模板',
        data: function () {
            return {
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                comnAllocForm: {
                    title: null,
                    sellerId: null,
                    sellerType: null,
                    sellerName: null,
                    allocForms: [],
                    itemList: []
                },
                comList: [],
                buyerId: null
            }
        },
        created: function () {
            this.getUserInfo();
        },
        methods: {
            changePrice: function (row) {
                if(!Utils.isMoneyStr(row.price, true)) {
                    Toast.show("请输入有效的价格");
                    return false;
                }
                if(!Utils.isNoB(row.taxRate)) {
                    row.ntxPrice = ( row.price / (1 + (row.taxRate * 0.01))).toFixed(2);
                }
            },
            taxRateChange: function (taxRate) {
                if(!Utils.isNoB(taxRate)) {
                    if(!Utils.isMoneyStr(taxRate)) {
                        taxRate = null;
                        MsgBox.warning("请输入正确的税率！");
                        return;
                    } else {
                        let taxRateF = parseFloat(taxRate);
                        if(taxRateF > 100) {
                            taxRate = null;
                            MsgBox.warning("税率不能超过100！");
                            return;
                        } else {
                            taxRate = taxRateF.toFixed(2);
                        }
                    }
                } else {
                    MsgBox.warning("请输入税率！");
                    return;
                }
                let comnAllocForm = this.comnAllocForm || [];
                let itemList = comnAllocForm.itemList;
                comnAllocForm.taxRate = taxRate;
                if(itemList.length > 0) {
                    for(let i = 0; i < itemList.length; i++) {
                        let item = itemList[i];
                        //
                        item.taxRate = taxRate;
                        if(Utils.isNoB(taxRate) || Utils.isNoB(item.price)) {
                            item.ntxPrice = item.price;
                        } else {
                            item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                        }
                    }
                }
                comnAllocForm.itemList = Utils.merge([], itemList);
                this.comnAllocForm = Utils.merge({}, comnAllocForm);
            },
            //
            getUserInfo(){
                let self = this;
                let theLoad = MsgBox.loading();
                userApi.getUserInfoByContext({}, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let data = result.data;
                        self.buyerId = data.merchantId;
                    }
                });
            },
            // 选择配货机构
            showShopDlg: function () {
                let self = this;
                let comList = this.comList || [];
                let params = {
                    showCheckboxLevel1: true,
                    showCheckboxLevel2: true,
                    showCheckboxLevel3: true,
                    checkStrictly: true
                };
                openRetailerComTreeMultiSelectDlg(params, comList, function (result) {
                    let comList = result.data || [];
                    if(comList.length > 10) {
                        Toast.show("最多选择10个机构！");
                        return;
                    }
                    self.comList = Utils.merge([], comList);
                    let allocFormList = [];
                    for(let i = 0; i < comList.length; i++) {
                        let comInfo = comList[i];
                        let item = {
                            buyerShopId: comInfo.comId,
                            buyerShopId1: comInfo.comId1,
                            buyerShopId2: comInfo.comId2,
                            buyerShopId3: comInfo.comId3,
                            buyerShopId4: comInfo.comId4,
                            buyerShopLevel: comInfo.comLevel,
                            buyerShopName: comInfo.comName,
                            buyerRecvContractName: comInfo.contactName,
                            buyerRecvContactTel: comInfo.contactTel,
                            contactEmail: comInfo.contactEmail,
                            desireArriveDate: (new Date()).format('yyyy-MM-dd')
                        };
                        self.getRetailerAddrListByComId(comInfo.comId, item, allocFormList)
                    }
                });
            },
            getRetailerAddrListByComId: function (shopId, allocForm, allocFormList) {
                let self = this;
                let postData = {};
                postData.comId = shopId;
                postData.merchantId = self.buyerId;
                postData.recvFlag = true;
                postData.defRevcFlag = true;
                //
                retailerApi.getRetailerAddrList(postData, function (result) {
                    if(result.type === "info") {
                        let addrList = result.data;
                        let retailerCom = self.retailerCom;
                        if(addrList != null && addrList.length > 0) {
                            let addr = addrList[0];
                            allocForm.buyerRecvRegionId = addr.regionId;
                            allocForm.buyerRecvRegionName = addr.regionName;
                            allocForm.buyerRecvStreet = addr.street;
                        } else {
                            allocForm.buyerRecvRegionId = retailerCom.regionId;
                            allocForm.buyerRecvRegionName = retailerCom.regionName;
                            allocForm.buyerRecvStreet = retailerCom.street;
                        }
                        //
                        allocFormList.push(allocForm);
                        self.comnAllocForm.allocForms = Utils.merge([], allocFormList);
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            // 移除配货机构
            removeRetailerCom: function (buyerShopId) {
                let allocForms = this.comnAllocForm.allocForms || [];
                if(allocForms.length > 0) {
                    for(let i = 0; i < allocForms.length; i++) {
                        let allocForm = allocForms[i];
                        if(allocForm.buyerShopId == buyerShopId) {
                            allocForms.splice(i, 1);
                            break;
                        }
                    }
                    this.comnAllocForm.allocForms = Utils.merge([], allocForms);
                }
                //
                let comList = this.comList || [];
                if(comList.length > 0) {
                    for(let i = 0; i < comList.length; i++) {
                        let comInfo = comList[i];
                        if(comInfo.comId == buyerShopId) {
                            comList.splice(i, 1);
                            break;
                        }
                    }
                    this.comList = Utils.merge([], comList);
                }
            },
            // 选择地址
            showShopAddrDlg: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '选择机构收货地址',
                    width: 800,
                    height: 500,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-retailer-addr-select :comId="comId" :checkBox = "false"  ref="swb_retailer_addr_list_select"></swb-retailer-addr-select>' +
                    '</div>',
                    data: {
                        comId: row.buyerShopId
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_retailer_addr_list_select.getDlgResult() || {};
                        if(result.type == 'info') {
                            let shopAddr = result.data;
                            row.buyerRecvRegionId = shopAddr.regionId;
                            row.buyerRecvRegionName = shopAddr.regionName;
                            row.buyerRecvStreet = shopAddr.street;
                            //
                            return true;
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    },
                    lifecycle: {}
                })
            },
            // 选择供应商
            sellerSelect: function () {
                let self = this;
                let params = {
                    showContract: true,
                    showOrder: true,
                    showAmbilateralBizRel: true,
                    showBizRel: true,
                    showAdverseBizRel: true,
                    showNoScoreBizRel: true,
                    showShieldedBizRel: true,
                    showAll: true,
                    multiSelect: false
                };
                let comnAllocForm = self.comnAllocForm;
                openVendorSelectComnDlg(self, params, function (result) {
                    let seller = result.checkedList;
                    comnAllocForm.sellerId = seller.id;
                    comnAllocForm.sellerName = seller.name;
                    comnAllocForm.sellerType = getEnumInfoWith('merchantType', 'name', 'Vendor').value;
                    self.comnAllocForm = Utils.merge({}, comnAllocForm);
                })
            },
            // 选择商品
            showSkuDlg: function () {
                let self = this;
                let comnAllocForm = self.comnAllocForm;
                if(Utils.isNoB(comnAllocForm.sellerId)) {
                    MsgBox.warning("请选择供应商信息");
                    return;
                }
                let filter = {
                    merchantId: comnAllocForm.sellerId,
                    merchantType: comnAllocForm.sellerType,
                    shelfState: 1,
                    saleHalted: false
                };
                let dbItemList = comnAllocForm.itemList || [];
                let taxRate = comnAllocForm.taxRate
                let skuIds = dbItemList.pluck("skuId") || [];
                openSkuListSelectDlg(true, filter, skuIds, function (result) {
                    let itemList = result || [];
                    itemList.forEach(function (item) {
                        item.skuId = item.id;
                        item.quantity = 0;
                        //
                        item.asmblAccFlag = false;
                        item.vendorUknoFlag = false;
                        item.setupFlag = false;
                        item.asmblFlag = false;
                        item.price = null;
                        item.ntxPrice = null;
                        item.taxRate = taxRate;
                        item.arriveDays = null;
                    });
                    comnAllocForm.itemList = dbItemList.concat(itemList);
                    self.comnAllocForm = Utils.merge({}, comnAllocForm);
                })
            },
            // 移除商品
            removeGoods: function (skuId) {
                let self = this;
                let comnAllocForm = self.comnAllocForm;
                let itemList = comnAllocForm.itemList;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(item.skuId == skuId) {
                        itemList.splice(i, 1);
                    }
                }
                comnAllocForm.itemList = itemList;
                self.comnAllocForm = Utils.merge({}, comnAllocForm);
            },
            // 返回数据
            getDlgResult: function () {
                let result = {};
                let comnAllocForm = this.comnAllocForm;
                let allocForms = comnAllocForm.allocForms || [];
                if(allocForms.length <= 0) {
                    result.type = 'warn';
                    result.message = "请选择配货机构！";
                } else {
                    if(Utils.isNoB(comnAllocForm.sellerId)) {
                        result.type = 'warn';
                        result.message = "请选择供应商信息！";
                    } else {
                        let itemList = comnAllocForm.itemList || [];
                        if(Utils.isNoB(itemList) || itemList.length <= 0) {
                            result.type = 'warn';
                            result.message = "请选择商品信息！";
                        } else {
                            result.type = 'info';
                            result.data = comnAllocForm;
                        }
                    }
                }
                return result;
            },

            submitClick: function () {
                let self = this;
                let comnAllocForm = self.comnAllocForm;
                if(Utils.isNoB(comnAllocForm.title)) {
                    Toast.show("请输入标题");
                    return false;
                }
                let allocForms = comnAllocForm.allocForms || [];
                if(allocForms.length <= 0) {
                    Toast.show("请选择配货机构！");
                    return false;
                } else {
                    for(let i = 0; i < allocForms.length; i++) {
                        let allocForm = allocForms[i];
                        if(!Utils.isNoB(allocForm.buyerRecvContactTel) && !Utils.isPhoneNo(allocForm.buyerRecvContactTel)) {
                            Toast.show("【" + allocForm.buyerShopName + "】联系电话错误！");
                            return false;
                        }
                        if(!Utils.isNoB(allocForm.desireArriveDate)) {
                            allocForm.desireArriveDate = allocForm.desireArriveDate.format("yyyy-MM-dd");
                        } else {
                            Toast.show("请选择到货日期！");
                            return false;
                        }
                    }
                }
                if(Utils.isNoB(comnAllocForm.sellerId)) {
                    Toast.show("请选择供应商信息！");
                    return false;
                }
                let itemList = comnAllocForm.itemList;
                if(Utils.isNoB(itemList) || itemList.length <= 0) {
                    Toast.show("请选择商品信息！");
                    return false;
                } else {
                    for(let i = 0; i < itemList.length; i++) {
                        let item = itemList[i];
                        if(!Utils.isNaturalStr(item.quantity, true)) {
                            Toast.show("【" + item.title + "】请输入有效的下单数量");
                            return false;
                        }
                    }
                }
                let loading = MsgBox.loading();
                goodsOrderApi.doSaveOrderGoodsAllocForm(comnAllocForm, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        MsgBox.success("保存成功");
                        self.$router.push({
                            path: SwbOrderGoodsAllocFormList.path,
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            goBack: function () {
                this.$router.push({
                    path: SwbOrderGoodsAllocFormList.path
                });
            }
        }
    }
</script>
<style>
    .el-date-editor.el-input {
        width: 320px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/order/OrderGoodsAllocFormTemplate.vue